import { render, staticRenderFns } from "./IpDisableList.vue?vue&type=template&id=6e623707&scoped=true&"
import script from "./IpDisableList.vue?vue&type=script&lang=js&"
export * from "./IpDisableList.vue?vue&type=script&lang=js&"
import style0 from "./IpDisableList.vue?vue&type=style&index=0&id=6e623707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e623707",
  null
  
)

export default component.exports